import React from 'react';
import './AnimatedBackground.css';

const AnimatedBackground = () => {
  const particles = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    delay: `${i * 0.5}s`,
    x: `${Math.random() * 100}%`,
    duration: `${15 + Math.random() * 10}s`,
  }));

  return (
    <div className="animated-bg">
      <div className="grid-overlay"></div>
      <div className="gradient-orb orb-1"></div>
      <div className="gradient-orb orb-2"></div>
      <div className="gradient-orb orb-3"></div>
      <div className="particles">
        {particles.map((particle) => (
          <div
            key={particle.id}
            className="particle"
            style={{
              '--delay': particle.delay,
              '--x': particle.x,
              '--duration': particle.duration,
            }}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default AnimatedBackground;
